import {initWJPackage} from './wj-package.js';
import {initWJPackagePricedetails} from './wj-package-pricedetails.js';
import {initWJPackageConditions} from './wj-package-conditions.js';
import {initWJPackageTariff} from './wj-package-tariff.js';
import {initWJSupplierReviews} from './wj-supplier-reviews.js';
import {initBCPackageSupplierDetails} from './bc-package-supplierdetails.js';
const initPackageComponents = () => {
  initWJPackageTariff();
  initWJSupplierReviews();
  initWJPackagePricedetails();
  initWJPackageConditions();
  initBCPackageSupplierDetails();
  initWJPackage();
};
export {initPackageComponents};
